import React from 'react';

export default function Dashboard() {
  return(
    <h2>Dashboard</h2>
  );
}
